import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteWinnerEvent: (
  fetchContext: FetchContext,
  programId: number,
  eventId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, programId, eventId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/winner-events/${eventId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete winner event'));
